import { create } from 'zustand'

interface PlayerInfoStore {
    balance: number
    winAmount: number
    winLabel: string
    isWinAmountAnimating: boolean
    isLastWin: boolean
    updateBalance: (newBalance: number) => void
    updateWinAmount: (newWinAmount: number) => void
    updateWinLabel: (newLabel: string, isLastWin: boolean) => void
    updateIsWinAmountAnimating: (isAnimating: boolean) => void
}

export const usePlayerInfoStore = create<PlayerInfoStore>((set) => ({
    balance: 0,
    winAmount: 0,
    winLabel: '',
    isWinAmountAnimating: false,
    isLastWin: false,
    updateBalance: (newBalance: number) => set(() => ({ balance: newBalance })),
    updateWinAmount: (newWinAmount: number) => set(() => ({ winAmount: newWinAmount })),
    updateWinLabel: (newLabel: string, isLastWin = false) => set(() => ({ winLabel: newLabel, isLastWin })),
    updateIsWinAmountAnimating: (isAnimating: boolean) => set({ isWinAmountAnimating: isAnimating }),
}))
